import { z } from "zod";
export const billingNoticeSchema = z.object({
    id: z.string().min(1).max(200),
    kind: z.enum(["credits_low", "credits_exhausted", "credit_limit", "payment_failed", "reconciliation_required"]),
    createdAt: z.number().int().nonnegative(),
}).strict();
export const billingNoticesSchema = z.object({ notices: z.array(billingNoticeSchema).max(32), canManageBilling: z.boolean() }).strict();
export const acknowledgeBillingNoticeSchema = z.object({ noticeId: billingNoticeSchema.shape.id }).strict();
/** The kinds an organisation's admins are told about as a notification; the others are the exact ledger's own detail. */
export const billingNoticeNotificationKindSchema = z.enum(["credits_low", "credits_exhausted", "payment_failed"]);
const billingNoticeNotificationSchema = z.object({ kind: billingNoticeNotificationKindSchema, aiPaused: z.boolean() });
/**
 * A billing notice as its notification reads, from the notification's presentation. Used-up credits pause AI only on
 * a plan that enforces; one that measures keeps working.
 */
export function billingNoticeNotificationCopy(presentation) {
    const { kind, aiPaused } = billingNoticeNotificationSchema.parse(presentation);
    switch (kind) {
        case "credits_low":
            return { title: "AI credits running low", body: "Your team has used 80% of this month's AI credits." };
        case "credits_exhausted":
            return aiPaused
                ? { title: "AI is paused", body: "Your team has used all of this month's AI credits. Add credits in Billing to continue." }
                : { title: "AI credits used up", body: "Your team has used all of this month's AI credits. AI keeps working for now." };
        case "payment_failed":
            return { title: "A payment didn't go through", body: "Check Billing to sort out the payment." };
    }
}
